import { render } from "./CreateDept.vue?vue&type=template&id=78ba55fb"
import script from "./CreateDept.vue?vue&type=script&lang=js"
export * from "./CreateDept.vue?vue&type=script&lang=js"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__